import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import * as Accordion from "@radix-ui/react-accordion";
import type { Swiper as SwiperType } from "swiper/types";
import logo from "../assets/nestfin/Nestfin_logo.png";

import { text } from "../text";
import { URLS } from "../config";
import { hooks } from "../hooks";
import { utils } from "../utils";
import { items } from "../items";
import { svg } from "../assets/svg";
import { theme } from "../constants";
import { components } from "../components";
import { course as elements } from "../course";
import properties from "../staticdata/properties";
import { reviewsData } from "../staticdata/reviewData";
import { ReviewCard } from "../reviews/reviewCard";
import { roomTypes } from "../staticdata/roomOptions";
import { FlatPrices } from "../items/Flattypes";
import { PropertiyOwner } from "../items/PropertyOwner";
import { BlockHeading } from "../components/BlockHeading";
import goal from "../assets/nestfin/goal.png";
import checkIcon from "../assets/nestfin/checklist.png";
import { WhatsappSvg } from "../assets/svg/WhatsappSvg";
import useApi from "../customHook/useApi";
import {
  fetchPropertyByFilters,
  getPropertyById,
  leadIdFromStorage,
  similarProperty,
  webCallLead,
} from "../environment";
import { callService } from "../customHook/callService";
import fallBackImg from "../assets/nestfin/No_image_Found.png";
import { CustomLoader } from "../components/CustomLoader";
import { CallSvg } from "../assets/svg/CallSvg";
import { ImageWithLoader } from "../course/ImageWithLoader";
import { Nestfin_Number } from "../constants/constantData";
import ContactOwnerModal from "../components/ContactOwnerModal";
import { Helmet } from "react-helmet-async";

type RoomOption = {
  property_room_option_id: string;
  property_id: string;
  room_type_id: string;
  option_name: string;
  unit_amount: number;
  created_at: string;
  gender_allowed: string;
  features: {
    id: string;
    name: string;
  }[];
};

type PropertyDetailState = {
  leadId: string;
  propertyId: string;
};

export interface Feature {
  icon: string;
  feature_id: number;
  feature_name: string;
}

export interface RoomType {
  room_type_id: string;
  room_type_name: string;
}

export interface PropertyType {
  property_id: string;
  property_name: string;
  contact_phone: string;
  contact_email: string;
  address: string;
  locality_id: string;
  locality_name: string | null;
  city_id: string;
  city_name: string;
  description: string;
  pincode: string;
  security_deposit_months: string;
  agreement_duration_months: string;
  noticeperiod_months: string;
  lockinperiod_months: string;
  state: string;
  features: Feature[];
  photos: any;
  minimum_rent: number;
  room_types: RoomType[];
  latitude: number;
  longitude: number;
  subscription_status: "Active" | "Inactive" | null;
  subscription_name: string | null;
  gender_allowed: string;
  category: string;
  organization_name: string;
  house_flat_block_no: string;
}

export interface APIResponse {
  success: boolean;
  statusCode: number;
  data: PropertyType[];
  message: string;
  isBooked: boolean;
  gender_allowed: string;
}

export interface FilterResponse {
  success: boolean;
  statusCode: number;
  data: PropertyType[];
}

const buttonTagStyle = {
  backgroundColor: "var(--secondary-color)",
  padding: "5px 10px",
  borderRadius: "8px",
  color: "white",
  cursor: "pointer",
  fontSize: "12px",
  letterSpacing: "1px",
  fontWeight: "bold",
};

const buttonTagStyle_absolute: React.CSSProperties = {
  backgroundColor: "#014d4e",
  color: "white",
  // padding: "10px 19px",
  padding: "7px 12px",
  borderRadius: "7px",
  fontSize: "12px",
  fontWeight: "bold",
  letterSpacing: "1px",
};

export const CourseDetails: React.FC = () => {
  const [isModalOpen2, setisModalOpen2] = useState(false);
  const location = useLocation();
  const { pathname } = useLocation();
  const navigate = hooks.useNavigate();
  const [coursesData, setCoursesData] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [propertiesDetailsData, setPropertiesDetailsData] =
    useState<PropertyType | null>(null);
  const course = location?.state?.course || {};
  // const { citySlug } = useParams();
  const propertyInfoSearch = location.search;
  let pathname_propertyInfo = propertyInfoSearch?.split("?id=")[1] || null;
  const propertyId_from_pathname: string | null =
    (pathname_propertyInfo && atob(pathname_propertyInfo)) || null;

  const [isShowContactModal, setIsShowContactModal] = useState<boolean>(false);
  const [showSuccessModal, setShowSuccessModal] = useState<boolean>(false);
  const [pendingWhatsappUrl, setPendingWhatsappUrl] = useState<string | null>(
    null,
  );

  console.log("pathname:", pathname);

  // console.log(location.state);
  // console.log("location: ", location);

  // console.log("====>>> location <<<====", location);
  // console.log("====>>> property info <<<====", pathname_propertyInfo);

  // const [selectedTab, setSelectedTab] = useState(tabs[0]);
  // const [openItem, setOpenItem] = useState<string | null>(null);

  const [propertiesDetail, setPropertryDetails] = useState<PropertyDetailState>(
    {
      leadId: "",
      propertyId: "",
    },
  );
  const [buttonLoad, setButtonLoad] = useState(false);

  useEffect(() => {
    // console.log("changed ==== >>>>", propertiesDetailsData);
    window.scrollTo({ top: 10, behavior: "smooth" });
  }, [propertiesDetailsData]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
    };
    scrollToTop();
  }, [pathname]);

  const [isImagePreviewOpen, setIsImagePreviewOpen] = useState(false);
  const [previewImageIndex, setPreviewImageIndex] = useState(0);

  // API CALL fetch propertydetails
  const {
    data: propertyDetailResponse,
    loading: propertyDetailLoading,
    callApi: fetchPropertyDetail,
  } = useApi<APIResponse>(getPropertyById, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  // CAll Api fetchBudgetFriendly
  const {
    data: fetchSimilarPropertyData,
    loading: fetchSimilarPropertyLoading,
    callApi: fetchBudgetNearMeFun,
  } = useApi<FilterResponse>(similarProperty, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  // console.log("location state", location.state);

  useEffect(() => {
    const propertyId =
      propertyId_from_pathname ||
      location?.state?.item?.property_id ||
      location?.state?.course?.property_id ||
      "";
    const leadId = localStorage.getItem("lead_profile_id") ?? "";

    setPropertryDetails({ leadId, propertyId });

    // console.log(leadId, "leadid", propertyId, "propertyid");

    fetchPropertyDetail({
      leadId: leadId,
      propertyId: propertyId,
      // leadId: "LEAD-B-2025-05-001",
      // propertyId: "PR-B-2025-05-078",
    });

    fetchBudgetNearMeFun({
      // leadId: leadId,
      propertyId: propertyId,
    });

    if (leadId && propertyId) {
      callService("VIEWED_PROPERTIES", [
        {
          param: "PROPERTY_ID",
          value: propertyId,
        },
      ])
        .then((res) => {
          // console.log("✅ VIEWED_PROPERTIES response:", res);

          // Set data if structure is like: { data: [ ... ] }
          if (res?.data?.length) {
            setPropertiesDetailsData(res.data[0]);
          }
        })
        .catch((err) => {
          console.error("❌ VIEWED_PROPERTIES API failed:", err);
        });
    }
  }, [location]);

  useEffect(() => {
    // console.log(fetchSimilarPropertyData?.data, "fetchSimilarPropertyData");
  }, [fetchSimilarPropertyData]);

  // console.log("location ", location.state.course.property_id)
  // console.log('====================================');
  // console.log("fetchproperty id ", propertiesDetail);
  // console.log('====================================');

  // ✅ Debug API response
  useEffect(() => {
    if (propertyDetailResponse) {
      // console.log("✅ propertyDetailResponse response:", propertyDetailResponse.data[0]);
      setPropertiesDetailsData(propertyDetailResponse?.data[0]);
    }
  }, [propertyDetailResponse]);

  // console.log(propertiesDetailsData, "-----property details data");

  // Call Lead API Call
  // useEffect(() => {

  // }, [])

  // fetch all property Here

  const callLeadServiceAPI = async () => {
    try {
      const response = await callService("PAID_BOOKING");
    } catch (error) {
      console.error("Error while calling PAID_BOOKING API", error);
    }
  };

  // CAll Api
  const {
    data: propertyData,
    loading: propertyLoading,
    callApi: fetchProperty,
  } = useApi<FilterResponse>(fetchPropertyByFilters, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  useEffect(() => {
    const leadId = localStorage.getItem("lead_profile_id") || "";
    const cityId = localStorage.getItem("selectedCityId") || "";
    const gender = localStorage.getItem("gender") || "";
    const maxAmountStr = localStorage.getItem("maxAmount") || "";
    const minAmountStr = localStorage.getItem("minAmount") || "";

    const isAddMinMax_Amount = localStorage.getItem("is_add_max_min");

    // // if (!cityId) return;
    // if (!cityId) {
    //   window.location.href = "/onbording5";
    // }

    // console.log("--------------- city", cityId, leadId);
    // ✅ Call API immediately
    const payload = {
      leadId: leadId,
      gender: gender,
      localityId: "",
      cityId: cityId,
      ...(isAddMinMax_Amount &&
        minAmountStr && { minAmount: Number(minAmountStr) }),
      ...(isAddMinMax_Amount &&
        maxAmountStr && { maxAmount: Number(maxAmountStr) }),
      // minAmount: minAmount,
      // maxAmount: maxAmount,
    };

    fetchProperty(payload);
    // console.log("Called API immediately with:", payload);
  }, []);

  const handleReuestOwnerCall = async (propertyId: any) => {
    const leadId = localStorage.getItem("lead_profile_id") ?? "";

    if (leadId && propertyId) {
      try {
        setButtonLoad(true); // start loading

        const res = await callService("CONTACT_OWNER", [
          {
            param: "PROPERTY_ID",
            value: propertyId,
          },
        ]);

        // console.log("✅ CONTACT_OWNER response:", res);
        setisModalOpen2(true);
      } catch (err) {
        console.error("❌ CONTACT_OWNER API failed:", err);
      } finally {
        setButtonLoad(false); // stop loading regardless of success or error
      }
    }
  };

  // Web Call Api
  const {
    data: WebCallApiData,
    loading: WebCallApiLoading,
    callApi: webCallPost,
  } = useApi(webCallLead, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  // const handleWebCallLead = async (propertyId: any, showModal: boolean) => {
  const handleWebCallLead = async (prefs: any) => {
    const selectedPropertyId = propertiesDetailsData?.property_id;
    if (!selectedPropertyId) return;

    const storedLeadId =
      leadIdFromStorage || localStorage.getItem("lead_profile_id");
    const payload = {
      property_id: selectedPropertyId,
      lead_id: storedLeadId,
      ...(prefs && prefs),
    };

    try {
      const response = await webCallPost(payload);
      console.log("API Response:", response);
      if (response?.success) {
        setIsShowContactModal(false);
      }
      if (showSuccessModal && response?.success) {
        setisModalOpen2(true);
        setShowSuccessModal(false);
      }
    } catch (error) {
      console.error("API call failed:", error);
    }
    // finally {
    //   // ✅ Always open WhatsApp — success or failure
    //   if (pendingWhatsappUrl) {
    //     window.open(pendingWhatsappUrl, "_blank");
    //     setPendingWhatsappUrl(null); // clean up
    //   }
    // }
  };

  const handleGetDirection = async (
    e: React.MouseEvent<HTMLAnchorElement>,
    course: any,
  ) => {
    e.stopPropagation();

    // console.log(
    //   "🧭 Propertiy Details Get Directions clicked for course:",
    //   course,
    // );

    // --- handleWebCallLead -----
    const propertyId = course?.propertId || propertiesDetailsData?.property_id;
    if (!propertyId) {
      console.warn("⚠️ Missing property_id for course:", course);
      return;
    }

    try {
      const response = await webCallPost({
        property_id: propertyId,
        lead_id: leadIdFromStorage || localStorage.getItem("lead_profile_id"),
        direction: true,
      });
    } catch (error) {
      console.error("API call failed:", error);
    }
    // handleWebCallLead(course?.propertId, false, true);

    try {
      const res = await callService("GET_DIRECTION", [
        {
          param: "PROPERTY_ID",
          value: course?.property_id || propertiesDetailsData?.property_id,
        },
      ]);
      if (res?.data?.length) {
        console.log("✅ GET_DIRECTION response:", res.data);
        // Optional: update state
        // setPropertiesDetailsData(res.data[0]);
      } else {
        console.warn("⚠️ No data returned from GET_DIRECTION");
      }
    } catch (error) {
      console.error("❌ GET_DIRECTION API failed:", error);
    }
  };

  // console.log("course --->>>", course);

  // Start Component Here
  const renderPreviewImage = (): JSX.Element => {
    const photosData = propertyDetailResponse?.data?.[0]?.photos;

    // console.log(photosData, "photodata coming from details page");

    const images: { photo_id: number | null; photo_path: string }[] =
      Array.isArray(photosData) && photosData.length > 0
        ? photosData.map((p: { photo_id?: number; photo_path?: string }) => ({
            photo_id: p.photo_id ?? null,
            photo_path: p.photo_path?.trim() ? p.photo_path : fallBackImg,
          }))
        : [{ photo_id: null, photo_path: fallBackImg }];

    return (
      <div
        style={{
          marginTop: 20,
          marginBottom: 20,
          position: "relative",
          maxWidth: 600,
          marginInline: "auto",
        }}
        className="container-fluid"
      >
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={16}
          slidesPerView={1}
          navigation={{
            nextEl: ".custom-next",
            prevEl: ".custom-prev",
          }}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          pagination={{ clickable: true }}
          loop
          style={
            {
              "--swiper-pagination-color": "#014d4e",
            } as React.CSSProperties
          }
        >
          {images?.map((image, index) => (
            <SwiperSlide key={index}>
              <div style={{ position: "relative" }}>
                {/* Image With Loader */}
                <ImageWithLoader
                  src={image.photo_path}
                  alt={`Preview ${index + 1}`}
                  style={{
                    width: "100%",
                    height: 200,
                    borderRadius: 10,
                    objectFit: "cover",
                    cursor: "pointer",
                  }}
                  className="rounded-img"
                />

                {/* Open Preview on Click */}
                <div
                  onClick={() => {
                    setPreviewImageIndex(index);
                    setIsImagePreviewOpen(true);
                  }}
                  style={{
                    position: "absolute",
                    inset: 0,
                    cursor: "pointer",
                  }}
                />

                {/* Custom Prev Button */}
                <button
                  className="custom-prev"
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "3px",
                    transform: "translateY(-50%)",
                    backgroundColor: "rgba(0, 0, 0, 0.45)",
                    color: "#fff",
                    border: "none",
                    borderRadius: "50%",
                    width: 25,
                    height: 25,
                    fontSize: 18,
                    cursor: "pointer",
                    zIndex: 10,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  ❮
                </button>

                {/* Custom Next Button */}
                <button
                  className="custom-next"
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "3px",
                    transform: "translateY(-50%)",
                    backgroundColor: "rgba(0, 0, 0, 0.45)",
                    color: "#fff",
                    border: "none",
                    borderRadius: "50%",
                    width: 25,
                    height: 25,
                    fontSize: 18,
                    cursor: "pointer",
                    zIndex: 10,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  ❯
                </button>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div
          style={{
            position: "absolute",
            // bottom: "10px",
            top: "10px",
            right: "30px",
            zIndex: 20,
            display: "flex",
            alignItems: "center",
            gap: "5px",
          }}
        >
          {propertiesDetailsData?.subscription_name?.toLowerCase() ==
            "premium" && <div style={buttonTagStyle_absolute}>Premium</div>}
          {propertyDetailResponse?.isBooked && (
            <div style={buttonTagStyle_absolute}>Booked</div>
          )}
        </div>
      </div>
    );
  };

  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        goBack={true}
        course={course}
        // addWishlist={true}
        // title={propertiesDetailsData?.property_name}
        centerImageSrc={logo}
      />
    );
  };

  const renderTopRatedCourses = (): JSX.Element | null => {
    if (fetchSimilarPropertyLoading) {
      return null;
    }
    if (
      !fetchSimilarPropertyData?.success ||
      !fetchSimilarPropertyData?.data?.length
    ) {
      return null;
    }
    return (
      <div style={{ marginBottom: 80, marginTop: 40 }}>
        <components.BlockHeading
          title="Similar Properties"
          viewAllOnClick={() => {
            navigate("/category-list", {
              state: {
                title: "Similar Properties",
                propertyList: fetchSimilarPropertyData?.data,
              },
            });
          }}
          containerStyle={{ marginBottom: 12, padding: "0 20px" }}
        />

        {fetchSimilarPropertyData?.data
          .slice(0, 3)
          .map((course: any, index, array) => {
            const isLast = index === array.length - 1;
            return (
              <elements.CourseCard
                key={course.id || index}
                course={course}
                isLast={isLast}
                section="top rated"
              />
            );
          })}
      </div>
    );
  };

  const renderLocationMap = (): JSX.Element => {
    // console.log(propertiesDetailsData, "propertiesDetailsData--- data 00000");
    // console.log(course, "property data 00000");
    const lat = propertiesDetailsData?.latitude;
    const lng = propertiesDetailsData?.longitude;
    const mapSrc = `https://www.google.com/maps?q=${lat},${lng}&z=15&output=embed`;
    const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
    // const isMapShow = propertiesDetailsData

    // console.log(mapSrc, "mapSrc");

    return (
      <div style={{ marginBottom: 0, marginTop: 40 }}>
        <components.BlockHeading
          title="Property Location"
          viewAllVisible={false}
          viewAllOnClick={() => {}}
          containerStyle={{ marginBottom: 12, padding: "0 20px" }}
        />

        <div
          style={{
            width: "100%",
            maxWidth: "600px",
            margin: "0 auto",
            textAlign: "center",
          }}
        >
          <iframe
            title="Property Location Map"
            src={mapSrc}
            width="100%"
            height="250"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>

          {/* Get Directions Button */}
          <a
            href={directionsUrl}
            target="_blank"
            // href="#"
            rel="noopener noreferrer"
            style={{
              display: "inline-block",
              marginTop: "12px",
              backgroundColor: "#014d4e",
              color: "#fff",
              padding: "10px 18px",
              borderRadius: "6px",
              textDecoration: "none",
              fontWeight: "bold",
            }}
            onClick={(e) => handleGetDirection(e, course)}
          >
            Get Directions
          </a>
        </div>
      </div>
    );
  };

  const renderKeyHighlights = (): JSX.Element => {
    // console.log("description ::----::", propertiesDetailsData);
    return (
      <div
        className="container whyYouChooseProperties"
        style={{
          marginBottom: 30,
          padding: "20px 28px",
          backgroundColor: "#f0fff0",
        }}
      >
        <div className="highlightContainer">
          <div className="highlightImage">
            <img src={goal} alt="Goal" />
          </div>
          <div className="highlightText">
            <p className="headingChoose">
              Key Highlights of This PG / Co-Living Property
            </p>
            {/* <p>Why you should choose the property</p> */}
          </div>
        </div>
        <ul className="whyChooseList">
          {propertiesDetailsData?.description?.trim() && (
            <li style={{ alignItems: "flex-start" }}>
              <img
                src={checkIcon}
                alt="check"
                className="listIcon"
                style={{ margin: "5px 10px 2px 0px" }}
              />
              <span style={{ lineHeight: "1.37rem" }}>
                {propertiesDetailsData?.description}
              </span>
            </li>
          )}
          <li>
            <img src={checkIcon} alt="check" className="listIcon" />
            Located in a Prime Area with Excellent Connectivity
          </li>
          <li>
            <img src={checkIcon} alt="check" className="listIcon" />
            PG Rooms Near Metro, IT Parks & Business Hubs
          </li>
          <li>
            <img src={checkIcon} alt="check" className="listIcon" />
            Modern, Fully Furnished Co-Living Spaces
          </li>
          <li>
            <img src={checkIcon} alt="check" className="listIcon" />
            Safe & Secure PG with 24/7 CCTV
          </li>
          <li>
            <img src={checkIcon} alt="check" className="listIcon" />
            Best PG Rent with High Comfort & Convenience
          </li>
        </ul>
      </div>
    );
  };
  // Function to render the Amenities as individual blocks

  // const renderCallButton = (): JSX.Element => {
  //   return (

  //   );
  // };

  const renderScheduleButton = (): JSX.Element => {
    return (
      <div
        style={{
          padding: "0px 20px",
          textAlign: "center",
          width: "100%",
          marginBottom: "20px",
        }}
      >
        {propertyDetailResponse?.isBooked && (
          <div
            style={{
              marginTop: "20px",
              // padding: "0px 20px",
              textAlign: "center",
              width: "100%",
              marginBottom: "20px",
            }}
          >
            <button
              className="ctaBtn2"
              style={{
                // backgroundColor: "orange",
                // color: "#ffffff",
                padding: "8px 24px",
                border: "none",
                borderRadius: "8px",
                fontSize: "16px",
                fontWeight: 600,
                cursor: "pointer",
                width: "100%",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                transition: "all 0.3s ease",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "6px",
              }}
              onClick={() => {
                const phone = propertiesDetailsData?.contact_phone;
                if (phone) {
                  // Open phone dialer
                  window.location.href = `tel:${phone}`;
                } else {
                  alert("Phone number not available");
                }
              }}
            >
              <CallSvg color={"#fff"} />
              Call Now
            </button>
          </div>
        )}
        <button
          className="ctaBtn1"
          style={{
            // backgroundColor: "orange",
            // backgroundColor: "var(--primary-color)",
            // color: "#ffffff",
            padding: "12px 24px",
            border: "none",
            borderRadius: "8px",
            fontSize: "16px",
            fontWeight: 600,
            cursor: "pointer",
            width: "100%",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
            transition: "all 0.3s ease",
          }}
          onClick={() => {
            const propertyId = propertiesDetailsData?.property_id;
            const propertyName = propertiesDetailsData?.property_name;
            if (propertyId) {
              localStorage.setItem("property_id", propertyId);
            }
            if (propertyName) {
              localStorage.setItem("property_name", propertyName);
            }
            navigate("/room-type", {
              state: {
                propertyData: propertiesDetailsData,
              },
            });
          }}
        >
          View Room Options
        </button>
      </div>
    );
  };

  // Render Component

  const renderTitle = (): JSX.Element => {
    // console.log(course);

    return (
      <div className="container propertiesDetails">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "5px",
            gap: "10px",
            width: "100%",
          }}
        >
          {/* Left side (buttons) */}
          <div style={{ display: "flex", gap: "6px", flexShrink: 0 }}>
            {propertiesDetailsData?.category && (
              <button style={buttonTagStyle}>
                {propertiesDetailsData.category.toUpperCase()}
              </button>
            )}

            {propertiesDetailsData?.gender_allowed && (
              <button style={buttonTagStyle}>
                {propertiesDetailsData.gender_allowed.toUpperCase()}
              </button>
            )}
            <button style={buttonTagStyle}>
              {(!!course?.is_meal_provided &&
                course?.is_meal_provided?.toLowerCase()) == "yes"
                ? "MEAL"
                : "NO MEAL"}
            </button>
          </div>

          {/* Right side (organization name) */}
          <div
            style={{
              flexGrow: 1,
              textAlign: "right",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              minWidth: 0,
              fontWeight: 600,
              fontSize: "14px",
              color: "#014d4e",
              letterSpacing: "0.2px",
              fontFamily: "Arial, sans-serif",
              cursor: "default",
            }}
            title={propertiesDetailsData?.organization_name}
          >
            {/* <span style={{ color: "#000", padding: "3px 0" }}>Org : </span> */}

            {propertiesDetailsData?.organization_name}
          </div>
        </div>

        <div>
          <text.H3 style={{ marginBottom: 6 }} numberOfLines={2}>
            {propertiesDetailsData?.property_name}
          </text.H3>
          <p style={{ lineHeight: "20px" }}>
            {`${propertiesDetailsData?.house_flat_block_no}, ${propertiesDetailsData?.address}`}
          </p>
        </div>
      </div>
    );
  };

  const renderFlatOpton = (): JSX.Element | null => {
    if (!propertiesDetailsData) return null;
    return (
      <div style={{ marginBottom: 20 }} className="container">
        <FlatPrices
          key={propertiesDetailsData.property_id}
          review={propertiesDetailsData}
          isLast={true}
        />
      </div>
    );
  };

  const renderOwner = (): JSX.Element | null => {
    if (!propertiesDetailsData) return null;

    return (
      <div
        // style={{ marginBottom: 20 }}
        className="container"
      >
        <PropertiyOwner
          key={propertiesDetailsData.property_id}
          review={propertiesDetailsData}
          isLast={true}
          onCalendarClick={() => navigate("/room-type")}
        />
      </div>
    );
  };

  const renderAmenities = (): JSX.Element | null => {
    // console.log(propertyDetailResponse?.data?.features);

    if (
      !propertiesDetailsData?.features ||
      propertiesDetailsData.features.length === 0
    ) {
      return null;
    }

    return (
      <div className="amenities-wrapper" style={{ marginBottom: 30 }}>
        <BlockHeading
          title="Amenities"
          viewAllOnClick={() => {
            navigate("/aminity-list", {
              state: {
                title: "Amenities List",
                features: propertiesDetailsData?.features || [],
              },
            });
          }}
          containerStyle={{ marginBottom: 12, padding: "0 20px" }}
        />

        <div className="amenities-grid">
          {propertiesDetailsData?.features?.length > 0 ? (
            propertiesDetailsData.features.slice(0, 6).map((item) => (
              <div key={item.feature_id} className="amenity-card">
                <div className="amenity-icon">
                  <img src={item.icon} alt={item.feature_name} />
                </div>
                <div className="amenity-name">{item.feature_name}</div>
              </div>
            ))
          ) : (
            <div className="no-data">No data found</div>
          )}
        </div>
      </div>
    );
  };

  const propertyDetails = (): JSX.Element | null => {
    if (!propertiesDetailsData) return null;

    const details = [];

    if (propertiesDetailsData.security_deposit_months) {
      details.push({
        label: "Security Deposit",
        value: propertiesDetailsData.security_deposit_months,
      });
    }

    if (propertiesDetailsData.noticeperiod_months) {
      details.push({
        label: "Notice Period",
        value: propertiesDetailsData.noticeperiod_months,
      });
    }

    // If no details exist, return null
    if (details.length === 0) return null;

    return (
      <div className="container">
        <div className="propertyContainer">
          <p className="property-details">Property Details</p>
          <div className="detailsValue">
            {details.map((item, index) => (
              <div className="propertyDetails-content" key={index}>
                <p>{item.label}</p>
                <p>{item.value}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  const renderBottomButton = (): JSX.Element => {
    return (
      <>
        <div className="container">
          <div className="bottom-button-container">
            <button
              onClick={() => {
                // console.log("property-details:", propertiesDetailsData);
                // console.log(
                //   "property-details-address:",
                //   propertiesDetailsData?.address,
                // );
                const currentPath = window.location.href;
                const propertyLink = currentPath.includes("?id=")
                  ? currentPath
                  : `${currentPath}/?id=${btoa(course.property_id || "")}`;

                // console.log("currentPath:", JSON.stringify(currentPath));
                // console.log("whtsp path:", JSON.stringify(propertyLink));
                // return;

                const message =
                  `Hey 👋,\n\n` +
                  `I found this interesting property and wanted to share with you:\n\n` +
                  // `🆔 *Property ID:* ${propertiesDetailsData?.property_id}\n` +
                  `🏠 ${propertiesDetailsData?.property_name}\n` +
                  `📍 ${propertiesDetailsData?.city_name}\n\n` +
                  `🔗 ${propertyLink}` +
                  `\n\nPlease check and share more info if you have. Thanks 🙂`;

                // console.log("whatspp messgae ", message);
                const response = webCallPost({
                  property_id: propertiesDetailsData?.property_id ?? "",
                  lead_id:
                    leadIdFromStorage ||
                    localStorage.getItem("lead_profile_id"),
                }).catch((error) => {
                  console.error("API call failed:", error);
                });
                // handleWebCallLead(propertiesDetailsData?.property_id, false);
                const encodedMessage = encodeURIComponent(message);
                const whatsappNumber = Nestfin_Number;
                // const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
                // const whatsappUrl = `https://wa.me/?text=${encodedMessage}`;
                const whatsappUrl = `https://api.whatsapp.com/send?text=${encodedMessage}`;

                window.open(whatsappUrl, "_blank");

                // setIsShowContactModal(true);
                // setPendingWhatsappUrl(whatsappUrl);
              }}
              className="bottom-button whatsapp-button"
            >
              <WhatsappSvg className="whatsapp-icon-animate" />
            </button>

            <button
              onClick={() => {
                setShowSuccessModal(true);
                setIsShowContactModal(true);
                // handleWebCallLead(propertiesDetailsData?.property_id, true);
              }}
              className="bottom-button call-button ctaBtn2"
              disabled={WebCallApiLoading}
            >
              Request Callback
            </button>

            <button
              onClick={() => {
                const propertyId = propertiesDetailsData?.property_id;
                const propertyName = propertiesDetailsData?.property_name;
                callLeadServiceAPI();
                // ✅ Only store if property_id exists
                if (propertyId) {
                  localStorage.setItem("property_id", propertyId);
                }

                if (propertyName) {
                  localStorage.setItem("property_name", propertyName);
                }

                navigate("/room-type", {
                  state: {
                    propertyData: propertiesDetailsData,
                  },
                });
              }}
              className="bottom-button request-button ctaBtn1"
              // style={{ backgroundColor: "orange", color:"white" }}
            >
              Book Now
            </button>

            {isModalOpen && (
              <div className="modal-overlay">
                <div className="modal-content">
                  <h2>Book Your Room</h2>
                  <form>
                    <label>
                      Select Room Type:
                      <select required>
                        <option value="">-- Choose an option --</option>
                        <option value="multi">Multi Sharing</option>
                        <option value="single">Single Sharing</option>
                        <option value="double">Double Sharing</option>
                        <option value="private">Private</option>
                      </select>
                    </label>

                    <label>
                      Payment Amount:
                      <input type="text" value="Rs. 10,000" readOnly />
                    </label>

                    <label>
                      GST (18%):
                      <input type="text" value="Rs. 1,800" readOnly />
                    </label>

                    <label>
                      Total Payable:
                      <input type="text" value="Rs. 11,800" readOnly />
                    </label>

                    <div className="modal-buttons">
                      <button
                        type="button"
                        className="cancel-button"
                        onClick={() => setIsModalOpen(false)}
                      >
                        Cancel
                      </button>
                      <div
                        className="pay-button"
                        onClick={() => navigate("/choose-payment-method")}
                      >
                        Confirm
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            )}
          </div>
        </div>

        {isShowContactModal && (
          <ContactOwnerModal
            setIsOpen={setIsShowContactModal}
            isSubmitting={WebCallApiLoading}
            handleSubmit={(prefs) => handleWebCallLead(prefs)}
          />
        )}
      </>
    );
  };

  const swiperRef = useRef<SwiperType | null>(null);

  // ---- current url to sahre ---
  const currentUrl = window.location.href;

  const renderContent = (): JSX.Element => {
    const photosData = propertyDetailResponse?.data?.[0]?.photos;

    // Prepare images array with fallback
    const images: { photo_id: number | null; photo_path: string }[] =
      Array.isArray(photosData) && photosData.length > 0
        ? photosData.map((p: { photo_id?: number; photo_path?: string }) => ({
            photo_id: p.photo_id ?? null,
            photo_path: p.photo_path?.trim() ? p.photo_path : fallBackImg,
          }))
        : [{ photo_id: null, photo_path: fallBackImg }];
    // console.log(propertyDetailResponse, "hello Vikas");
    return (
      <main style={{ paddingBottom: 0 }}>
        {renderPreviewImage()}
        {renderTitle()}
        {renderFlatOpton()}
        {renderOwner()}
        {renderScheduleButton()}
        {propertyDetails()}
        {renderAmenities()}
        {renderKeyHighlights()}
        {renderLocationMap()}
        {renderTopRatedCourses()}
        {renderBottomButton()}
        {isImagePreviewOpen && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.8)",
              zIndex: 9999,
            }}
          >
            {/* Close Button */}
            <button
              onClick={() => setIsImagePreviewOpen(false)}
              style={{
                position: "absolute",
                top: 20,
                right: 20,
                background: "transparent",
                border: "none",
                color: "#fff",
                fontSize: 28,
                cursor: "pointer",
                zIndex: 10000,
              }}
            >
              ✕
            </button>

            {/* Custom Prev Button */}
            <button
              onClick={() => swiperRef?.current?.slidePrev()}
              style={{
                position: "absolute",
                left: 20,
                top: "50%",
                transform: "translateY(-50%)",
                fontSize: 40,
                color: "#fff",
                background: "transparent",
                border: "none",
                cursor: "pointer",
                zIndex: 10000,
              }}
            >
              ‹
            </button>

            {/* Custom Next Button */}
            <button
              onClick={() => swiperRef?.current?.slideNext()}
              style={{
                position: "absolute",
                right: 20,
                top: "50%",
                transform: "translateY(-50%)",
                fontSize: 40,
                color: "#fff",
                background: "transparent",
                border: "none",
                cursor: "pointer",
                zIndex: 10000,
              }}
            >
              ›
            </button>

            {/* Swiper Fullscreen View */}
            <Swiper
              initialSlide={previewImageIndex}
              onSlideChange={(swiper: SwiperType) =>
                setPreviewImageIndex(swiper.activeIndex)
              }
              onSwiper={(swiperInstance: SwiperType) =>
                (swiperRef.current = swiperInstance)
              }
              spaceBetween={10}
              style={{ height: "100%", width: "100%" }}
            >
              {/* {course?.previewImages?.map?.((image: string, index: number) => ( */}
              {images?.map?.((image: any, index: number) => {
                // ✅ Debug the image coming into Swiper
                console.log("Fullscreen Swiper Image:", {
                  index,
                  image,
                  path: image?.photo_path,
                });
                return (
                  <SwiperSlide key={index}>
                    <div
                      style={{
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={image?.photo_path}
                        alt={`Fullscreen ${index + 1}`}
                        style={{
                          maxHeight: "90%",
                          maxWidth: "90%",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        )}
      </main>
    );
  };
  return (
    <>
      <Helmet>
        <link rel="canonical" href={currentUrl} />
        <meta property="og:url" content={currentUrl} />
        <meta
          property="og:title"
          content={`${propertiesDetailsData?.property_name} | NestFin`}
        />
      </Helmet>
      <div style={{ marginBottom: "85px" }}>
        {renderHeader()}
        {propertyDetailLoading ? (
          <> {CustomLoader()} </>
        ) : (
          <> {renderContent()}</>
        )}

        {isModalOpen2 && (
          <div className="modal-overlay">
            <div className="modal-content">
              <h2></h2>
              <p></p>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <img
                  alt="Success"
                  // src={"../assets/nestfin/Nestfin_logo.png"}
                  src={require("../assets/nestfin/Nestfin_logo.png")}
                  style={{ width: "50%", height: "auto", marginBottom: 10 }}
                />
                <img
                  alt="Success"
                  // src='https://george-fx.github.io/nuton_api/assets/images/08.png'
                  src={require("../assets/other/checked.png")}
                  style={{ width: "30%", height: "auto", margin: "30px 0" }}
                />
                <h2 style={{ textAlign: "center", marginBottom: 10 }}>
                  Request Sent Successfully
                </h2>
                <text.T16
                  style={{
                    whiteSpace: "pre-line",
                    textAlign: "center",
                    marginBottom: 24,
                  }}
                >
                  The owner will get in touch with you shortly.
                </text.T16>
                <div
                  onClick={() => {
                    setisModalOpen2(false);
                  }}
                  style={{
                    width: "100%",
                    color: theme.colors.white,
                    height: 40,
                    textAlign: "center",
                    fontSize: 14,
                    borderRadius: 10,
                    userSelect: "none",
                    cursor: "pointer",
                    textTransform: "capitalize",
                    background: "#000000d1",
                    fontFamily: "Lato-Bold",
                    marginTop: 12, // optional spacing
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  Continue
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
